export default {
  // Este componente no tiene cadenas traducibles estáticas
  // Usa datos dinámicos pasados desde props
}
